import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";

function MenuQR() {
  const [menu, setMenu] = useState([]);

  const fetchMenuData = async () => {
    // setLoading(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_KEY}/menu/getMenu/674586f39aa6780fb2688685`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of Fetching menu: ", response.data);
        setMenu(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchMenuData();
  }, []);
  return (
    <div className="bg-white text-center m-6 md:m-16">
      <div className="my-8 flex w-full flex-col items-center gap-2 bg-slate-50 p-8 text-center">
        {menu?.data?.length > 0 ? (
          <>
            <h1 className="text-xl font-medium">
              <a
                href={menu?.data?.[0]?.menuURL}
                className="font-bold text-blue-500 duration-300 hover:scale-105 hover:underline"
              >
                Clik Here
              </a>{" "}
              to view the Menu
            </h1>

            <p className="font-medium">
              Or <br />{" "}
              <span className="text-2xl font-semibold text-orange-500">
                Scan this QR Code
              </span>
            </p>
            <div className="relative">
              <img
                src={menu?.data?.[0]?.qrURL}
                alt=""
                className="h-64 w-64 duration-300 ease-in-out hover:scale-105 mb-8"
              />
            </div>
          </>
        ) : (
          <p className="text-lg font-medium">
            No menu available. Please add one
          </p>
        )}
      </div>
    </div>
  );
}

export default MenuQR;
